import React from 'react'

import { LuHome } from 'react-icons/lu'
import { twMerge } from 'tailwind-merge'

import { Navbar } from '@/components/library-v2/ui/Navbar'
import { Sidebar } from '@/components/library-v2/ui/Sidebar'

interface LayoutProps {
  children: React.ReactNode
  className?: string
}

export const Layout: React.FC<LayoutProps> = ({ children, className }) => {
  return (
    <>
      <div className="md:hidden flex h-full w-full items-center justify-center">
        <span className="text-sm text-primary-500 dark:text-primary-400">
          Please use a desktop browser to view this page.
        </span>
      </div>
      <div className={twMerge('hidden md:flex h-full w-full', className)}>
        <div className="h-full truncate w-[212px] lg:w-[246px] min-w-[212px] lg:min-w-[246px] max-w-[212px] lg:max-w-[246px] border-r border-primary-200 dark:border-primary-800">
          <Sidebar />
        </div>
        <div className="hidden md:block flex-1 h-full w-[calc(100%-246px)]">
          {children}
        </div>
      </div>
    </>
  )
}

interface LayoutMainProps {
  children: React.ReactNode
  className?: string
}

export const LayoutMain: React.FC<LayoutMainProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'flex flex-col h-full w-full divide-y divide-primary-200 dark:divide-primary-800',
        className,
      )}
    >
      {children}
    </div>
  )
}

export const LayoutNavbar = Navbar

interface LayoutContentProps {
  children: React.ReactNode
  className?: string
}

export const LayoutContent: React.FC<LayoutContentProps> = ({
  children,
  className,
}) => {
  return (
    <div className={twMerge('flex-1 h-[calc(100%-48px)] w-full', className)}>
      {children}
    </div>
  )
}

// Icon-only: inside the standard trail the root is a compact icon box (the
// chat panel pattern); a visible "Home" label would widen it into a pill.
export const HomeBreadcrumb: React.FC = () => {
  return (
    <div className="flex items-center" aria-label="Home">
      <LuHome size={15} />
      <span className="sr-only">Home</span>
    </div>
  )
}
